import { useIsMobile } from '@/hooks';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function ConfirmDeleteDialog({
  open,
  onOpenChange,
  title,
  description,
  isSubmitting,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  isSubmitting: boolean;
  onConfirm: () => void;
}) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={onOpenChange}>
        <DrawerContent>
          <DrawerHeader>
            <DrawerTitle>{title}</DrawerTitle>
          </DrawerHeader>
          <DrawerBody>
            <DrawerDescription>{description}</DrawerDescription>
            <DrawerFooter>
              <Button
                variant="primary-pill"
                disabled={isSubmitting}
                onClick={onConfirm}>
                {t('actions.löschen')}
              </Button>
              <Button
                variant="secondary-blue"
                onClick={() => onOpenChange(false)}>
                {t('actions.abbrechen')}
              </Button>
            </DrawerFooter>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter variant="default">
          <Button variant="secondary-blue" onClick={() => onOpenChange(false)}>
            {t('actions.abbrechen')}
          </Button>
          <Button
            variant="primary-pill"
            disabled={isSubmitting}
            onClick={onConfirm}>
            {t('actions.löschen')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
